import type { IconProps } from "./icon-types";

/**
 * File 공용 UI glyph.
 *
 * Lucide의 `LuFile` geometry를 정적 SVG로 인라인 — c6 패키지는 외부 아이콘
 * 라이브러리를 런타임 의존하지 않는다(RFC-design-system-split §아이콘).
 */
export const FileIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
    <path d="M14 2v4a2 2 0 0 0 2 2h4" />
  </svg>
);
